export type SocialNetworkName = "Instagram" | "Facebook" | "Youtube" | "TikTok" | "X";
export const socialChannelNames = ["facebook", "instagram", "twitter", "linkedin", "tiktok", "youtube"] as const;

export type SocialChannels = (typeof socialChannelNames)[number];

export function capitalizeSocialNetworkName(socialNetworkName: string): string {
  const lowercaseName = socialNetworkName.toLowerCase();

  switch (lowercaseName) {
    case "instagram":
      return "Instagram";
    case "facebook":
      return "Facebook";
    case "youtube":
      return "YouTube";
    case "tiktok":
      return "TikTok";
    case "twitter":
      return "Twitter";
  }
}
